var React = require('react');

function Prev (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.9 12.25a.6.6 0 01-.37-.14l-5.8-4.66a.6.6 0 010-.93L9.52 1.9a.6.6 0 01.74.93L5.06 6.99l5.22 4.2a.6.6 0 01-.38 1.06z"}));
}

Prev.defaultProps = {"viewBox":"0 0 14 14"};

module.exports = Prev;

Prev.default = Prev;
